// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h7-6";
export var emphasizeQuantity = "_h7-3";
export var flatBottomCorners = "_h7-5";
export var productImage = "_h7-0";
export var quantityContainer = "_h7-2";
export var tooltip = "_h7-1";
export var wrapAndEllipsesOverflow = "_h7-4";